import { cva, type VariantProps } from "class-variance-authority";

export type ChartData = {
	name: string;
} & {
	[key: string]: number | string;
};

export type DataKey<T extends ChartData> = Exclude<keyof T, "name">;

export interface ChartDataProps<T extends ChartData> {
	data: T[] | undefined;
	dataKeys: Array<DataKey<T>>;
	dataKeyClasses?: Record<DataKey<T>, Required<VariantProps<typeof colorClasses>>["color"]>;
}

export const colorClasses = cva([], {
	variants: {
		color: {
			// --- Your Custom Theme Colors ---
			salmon: "fill-salmon-500!",
			fern: "fill-fern-500!",
			jade: "fill-jade-500!",
			azure: "fill-azure-500!",
			"ember-blaze": "fill-ember-blaze-500!", // Quoted key for hyphenated color

			// --- Redefined / Explicitly Listed Colors ---
			gray: "fill-gray-500!",
			red: "fill-red-500!",
			yellow: "fill-yellow-500!",
			teal: "fill-teal-500!",
			blue: "fill-blue-500!",
			purple: "fill-purple-500!",
			violet: "fill-violet-500!",
			emerald: "fill-emerald-500!",

			// --- Remaining Standard Tailwind Colors ---
			slate: "fill-slate-500!",
			zinc: "fill-zinc-500!",
			neutral: "fill-neutral-500!",
			stone: "fill-stone-500!",
			orange: "fill-orange-500!",
			amber: "fill-amber-500!",
			lime: "fill-lime-500!",
			green: "fill-green-500!",
			cyan: "fill-cyan-500!",
			sky: "fill-sky-500!",
			indigo: "fill-indigo-500!",
			fuchsia: "fill-fuchsia-500!",
			pink: "fill-pink-500!",
			rose: "fill-rose-500!",
		},
	},
});
